import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

export interface TopBarStyles {
    infoBar?: InjectableCss;
    barWrapper: InjectableCss;
    barRestrictedWidthWrapper: InjectableCss;
}

export interface OwnProps {
    contentId: string;
}

const topBarStyles: TopBarStyles = {
    infoBar: {
        css: css`
            display: flex;
            flex: 0 0 100%;
            justify-content: center;
        `,
    },
    barWrapper: {
        css: css`
            display: flex;
            opacity: 1;
            align-items: center;
        `,
    },
    barRestrictedWidthWrapper: {
        css: css`
            max-width: none;
            width: 100%;
            display: flex;
            margin: auto;
        `,
    },
};

type Props = OwnProps;

const InfoBar: React.FC<Props> = ({ contentId }) => {
    return (
        <StyledWrapper {...topBarStyles.barWrapper}>
            <StyledWrapper {...topBarStyles.barRestrictedWidthWrapper}>
                <StyledWrapper {...topBarStyles.infoBar}>
                    <Zone contentId={contentId} zoneName="InformationBar" />
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default InfoBar;
